<template>
  <div class="web-preview" v-loading="!secureUrl">
    <div class="u-mt2 u-mb4">
      <span class="u-text--light u-text--sm">Portal preview (shows branded login screen):</span>
    </div>
    <div class="u-mb5"><a :href="url" target="_blank">{{url}}</a></div>
    <div v-if="secureUrl" class="web-preview__browser">
      <div class="web-preview__browser-bar">
        <span class="web-preview__dot"></span>
        <span class="web-preview__dot"></span>
        <span class="web-preview__dot"></span>
        <span class="web-preview__address">{{secureUrl}}</span>
      </div>
      <iframe :src="secureUrl" class="web-preview__iframe"></iframe>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ba-web-preview',
    props: ['url'],
    computed: {
      secureUrl () {
        if (!this.url) return ''
        return this.url.replace(/^http:\/\//, 'https://')
      }
    },
  }
</script>

<style scoped>
  .web-preview__browser {
    border: 1px solid #dcdfe6;
    border-radius: 6px;
    overflow: hidden;
    max-width: 900px;
    margin: 0 auto;
    box-shadow: 0 2px 12px rgba(0,0,0,.1);
  }
  .web-preview__browser-bar {
    background: #f5f5f5;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #dcdfe6;
  }
  .web-preview__dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #dcdfe6;
    margin-right: 6px;
  }
  .web-preview__dot:nth-child(1) { background: #ff5f57; }
  .web-preview__dot:nth-child(2) { background: #ffbd2e; }
  .web-preview__dot:nth-child(3) { background: #28ca41; }
  .web-preview__address {
    margin-left: 12px;
    font-size: 12px;
    color: #909399;
    background: white;
    padding: 3px 10px;
    border-radius: 3px;
    border: 1px solid #dcdfe6;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .web-preview__iframe {
    width: 100%;
    height: 500px;
    border: none;
    display: block;
  }
</style>
